import { FC } from 'react';
import classNames from 'classnames';
import { Icon } from 'common-components';
import { useTranslationContext } from '../../contexts/translationContext';
import DateRangeCalendar from '../dateRange/dateRange';
import Tag from '../../tag/tag';
import { SelectTimeFrameProps, TimeFrame } from './selectTimeFrameTypes';
import styles from './selectTimeFrame.module.scss';

const today = new Date();
export const fromAndTo = {
    Today: {
        from: new Date(today.getFullYear(), today.getMonth(), today.getDate()),
        to: today
    },
    PastWeek: {
        from: new Date(today.getFullYear(), today.getMonth(), today.getDate() - 7),
        to: today
    },
    PastMonth: {
        from: new Date(today.getFullYear(), today.getMonth() - 1, today.getDate()),
        to: today
    },
    PastYear: {
        from: new Date(today.getFullYear() - 1, today.getMonth(), today.getDate()),
        to: today
    }
};

const SelectTimeFrame: FC<SelectTimeFrameProps> = (props: SelectTimeFrameProps) => {
    const { limitUntil, selectedTimeFrame, onSelectTimeFrame, selectTimeFrameRef } = props;
    const { translate } = useTranslationContext();
    const isCustomTimeFrame = selectedTimeFrame?.timeFrame === TimeFrame.CUSTOM;

    const onChangeTimeFrame = (timeFrame: string) => {
        const isNewTimeFrame = selectedTimeFrame?.timeFrame !== timeFrame;
        const newTimeFrame = isNewTimeFrame ? timeFrame : undefined;
        const fromAndToTimeFrame = isNewTimeFrame ? fromAndTo[timeFrame] : undefined;
        const from = timeFrame === TimeFrame.CUSTOM ? undefined : fromAndToTimeFrame?.from;
        const to = timeFrame === TimeFrame.CUSTOM ? undefined : fromAndToTimeFrame?.to;
        onSelectTimeFrame(newTimeFrame, from, to);
    };

    return (
        <div className={styles.wrapper} ref={selectTimeFrameRef}>
            <div className={styles['tags-wrapper']}>
                {Object.values(TimeFrame).map((tag, index) => (
                    <Tag
                        key={index}
                        tagKey={tag}
                        title={
                            <div className={styles.tag}>
                                {translate(tag)}
                                {tag === TimeFrame.CUSTOM && (
                                    <Icon
                                        name="chevronDown"
                                        className={classNames(styles.icon, {
                                            [styles['checked-icon']]: isCustomTimeFrame
                                        })}
                                    />
                                )}
                            </div>
                        }
                        onTagClick={(tag: string) => onChangeTimeFrame(tag)}
                        isCheckedCallback={selectedTimeFrame?.timeFrame === tag}
                    />
                ))}
            </div>
            {isCustomTimeFrame && (
                <DateRangeCalendar
                    from={selectedTimeFrame?.from}
                    to={selectedTimeFrame?.to}
                    setFromAndTo={(from?: Date, to?: Date) => onSelectTimeFrame(selectedTimeFrame?.timeFrame, from, to)}
                    limitUntil={limitUntil}
                />
            )}
        </div>
    );
};

export default SelectTimeFrame;
